import { render } from "./MyFxForm.vue?vue&type=template&id=1f5169f6"
import script from "./MyFxForm.vue?vue&type=script&lang=js"
export * from "./MyFxForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__